import { useQuery } from '@tanstack/react-query';

import { type PolicyGroup } from '~entities/events/modal/event';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';
import { type Field, type Room } from '~shared/types/field';

export interface GetEventResponse {
  _id: string;
  title: string;
  hide: boolean;
  autoHideAfterEnd?: boolean;
  autoHideGraceHours?: number;
  includeInPublicSchedule?: boolean;
  color: string;
  studio: string;
  studentCount: number;
  students: Array<unknown>;
  costumeFee?: number;
  session: Session;
  location?: {
    fieldName: string;
    _id: string;
  };
  days: Array<string>;
  startTime: string;
  endTime: string;
  duration: number;
  registrationStartDate?: string;
  registrationEndDate?: string;
  startDate: string;
  endDate: string;
  tuitionFee: number;
  maxSize: number;
  maxWait: number;
  oneTime: boolean;
  allowOnlineRegistration: boolean;
  allowPortalEnrollment: boolean;
  allowTrialEnrollment: boolean;
  allowSpecificDatesSelection?: boolean;
  displayOnWebsite: boolean;
  tuitionBillingMethod: string;
  tuitionBillingCycle: string;
  tuitionDiscountRule: string;
  prorateTuition: boolean;
  registrationFee: boolean;
  registrationFeeAmount?: number;
  description?: string;
  mainTeacher: string;
  subTeacher: string;
  // startAge: number;
  // endAge: number;
  startYear: number;
  endYear: number;
  startMonth: number;
  endMonth: number;
  calendarId_ghl: string;
  productId_ghl: string;
  room?: Room;
  instructor?: Array<{
    _id: string;
    fieldName: string;
  }>;
  tags?: Array<Field<'tags'>>;
  group?: Array<Field<'group'>>;
  policyGroup?: Array<PolicyGroup>;
  schedules?: Array<string>;
  availability: Array<{
    day: string;
    startTime: string;
    endTime: string;
  }>;
  timeConfig: string;
  remainingSeats: number;
  imageUrl?: string;
  webpImageUrl?: string;
  originalImageUrl?: string;
  defaultImageUrl?: string;
  billingDay: number;
  billingFrequencyDays?: number;
}

interface GetEventParams {
  eventId: string;
}

interface Session {
  _id: string;
  name: string;
  startDate: string;
  endDate: string;
  isRegistrationFee: boolean;
  registrationFeeAmount: number;
}

export const getEventAPI = async (params: GetEventParams) => {
  const response = await baseAPI.get<GetEventResponse>(
    `/events/${params.eventId}`,
  );
  return response.data;
};

export const useGetEvent = (params: GetEventParams) => {
  return useQuery({
    queryKey: [KEYS.EVENTS, params.eventId],
    queryFn: () => getEventAPI(params),
    staleTime: 1000 * 60 * 5,
    retry: false,
  });
};
